<template>
  <div
    class="el-table energy-table none-height flex-grow-1
     d-flex flex-column el-table--fit el-table--striped el-table--small
     el-table--enable-row-hover el-table--enable-row-transition"
    style="width: 100%; height: 0px"
    :class="{'dark':skinType}"
  >
    <div class="hidden-columns">
      <div data-v-5f50b7a1=""></div>
      <div data-v-5f50b7a1=""></div>
      <div data-v-5f50b7a1=""></div>
      <div data-v-5f50b7a1=""></div>
      <div data-v-5f50b7a1=""></div>
    </div>
    <div class="el-table__header-wrapper">
      <table
        cellspacing="0"
        cellpadding="0"
        border="0"
        class="el-table__header"
        style="width: 100%"
      >
        <colgroup>
          <col name="el-table_4_column_10" width="254" />
          <col name="el-table_4_column_11" width="252" />
          <col name="el-table_4_column_12" width="252" />
          <col name="el-table_4_column_13" width="252" />
          <col name="el-table_4_column_14" width="252" />
        </colgroup>
        <thead class="">
          <tr class="">
              <th  v-for="(header,index) of tableData.headers"
               class="el-table_4_column_10 is-leaf" :key="'header'+index">
                <div class="cell">{{header}}</div>
              </th>
          </tr>
        </thead>
      </table>
    </div>
    <div class="el-table__body-wrapper is-scrolling-none none-height flex-grow-1"
    style="overflow:wrap;">
      <table
        cellspacing="0"
        cellpadding="0"
        border="0"
        class="el-table__body"
        style="width: 100%"
      >
        <colgroup>
          <col name="el-table_4_column_10" width="254" />
          <col name="el-table_4_column_11" width="252" />
          <col name="el-table_4_column_12" width="252" />
          <col name="el-table_4_column_13" width="252" />
          <col name="el-table_4_column_14" width="252" />
        </colgroup>
        <tbody>
          <tr
            class="el-table__row "
            :class="[{ 'el-table__row--striped': index % 2 == 0 },{'dark text-white':skinType}]"
            v-for="(rowItem, index) of tableData.data"
            :key="'row' + index"
          >
            <td
              v-for="(prop, order) of tableData.props"
              :key="'order-' + order"
            >
              <div class="cell">{{ rowItem[prop] }}</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="el-table__column-resize-proxy" style="display: none"></div>
  </div>
</template>
<script>
export default {
  name: 'energy-table',
  props: {
    tableData: {
      type: Object,
      default() {
        return {
          headers: [],
          data: [],
          props: [],
        };
      },
    },
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
  },
};
</script>
<style scoped>
.el-table__body-wrapper.is-scrolling-none {
  overflow-y: auto;
}
</style>
